import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';

const Liquidity = () => {
  return (
    <section className="py-32 px-4 relative">
      <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-20 items-center">
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <h2 className="text-4xl md:text-5xl font-bold mb-10 text-white">Market <span className="text-gradient">Structure</span></h2>
          <div className="space-y-6">
            <div className="glass-panel p-8 rounded-3xl border-l-[6px] border-l-cyan-400 hover:bg-[#ffffff0a] transition-colors">
              <h3 className="text-2xl font-bold mb-3 flex items-center gap-3 text-white">
                <SafeIcon name="TrendingUp" className="text-cyan-400" /> Gradual Liquidity Growth
              </h3>
              <p className="text-slate-300 leading-relaxed font-light">Liquidity is added strategically to ensure healthy market depth without artificial inflation.</p>
            </div>
            <div className="glass-panel p-8 rounded-3xl border-l-[6px] border-l-purple-400 hover:bg-[#ffffff0a] transition-colors">
              <h3 className="text-2xl font-bold mb-3 flex items-center gap-3 text-white">
                <SafeIcon name="Target" className="text-purple-400" /> Organic Price Discovery
              </h3>
              <p className="text-slate-300 leading-relaxed font-light">Letting the market decide the value based on utility, staking demand, and actual ecosystem growth.</p>
            </div>
            <div className="glass-panel p-8 rounded-3xl border-l-[6px] border-l-pink-400 hover:bg-[#ffffff0a] transition-colors">
              <h3 className="text-2xl font-bold mb-3 flex items-center gap-3 text-white">
                <SafeIcon name="Shield" className="text-pink-400" /> No Artificial Pumps
              </h3>
              <p className="text-slate-300 leading-relaxed font-light">Built for sustainability. We prioritize long-term holders over short-term manipulators.</p>
            </div>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1 }}
          className="relative"
        >
          {/* Premium Dashboard Mockup */}
          <div className="glass-panel rounded-[2.5rem] p-8 border border-white/10 shadow-[0_20px_50px_rgba(0,0,0,0.5)] relative overflow-hidden group">
            <div className="absolute top-0 right-0 w-80 h-80 bg-cyan-500/10 rounded-full blur-[80px] group-hover:bg-cyan-500/20 transition-colors duration-700" />
            <div className="absolute bottom-0 left-0 w-80 h-80 bg-purple-500/10 rounded-full blur-[80px] group-hover:bg-purple-500/20 transition-colors duration-700" />
            
            <div className="flex justify-between items-center mb-10 border-b border-white/10 pb-6 relative z-10">
              <div className="flex items-center gap-4">
                <div className="flex -space-x-3">
                  <div className="w-12 h-12 bg-gradient-to-br from-purple-500 to-fuchsia-600 rounded-full flex items-center justify-center font-bold text-white shadow-lg border-2 border-[#030014]">D</div>
                  <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-cyan-600 rounded-full flex items-center justify-center font-bold text-white shadow-lg border-2 border-[#030014]">X</div>
                </div>
                <span className="font-bold text-2xl text-white tracking-wide">Alcor Pools</span>
              </div>
              <span className="text-sm font-semibold bg-green-500/10 text-green-400 px-4 py-2 rounded-full border border-green-500/20 shadow-[0_0_15px_rgba(34,197,94,0.2)]">Active</span>
            </div>

            <div className="space-y-4 relative z-10">
              {['DKT / XPR', 'DKT / USDC', 'DKT / UBQTX'].map((pool, i) => (
                <a 
                  key={i} 
                  href="https://alcor.exchange/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex justify-between items-center p-6 bg-[#ffffff05] rounded-2xl hover:bg-[#ffffff10] transition-all duration-300 cursor-pointer border border-white/5 hover:border-white/20 group/row"
                >
                  <span className="font-mono text-lg text-slate-200 group-hover/row:text-white">{pool}</span>
                  <div className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center group-hover/row:bg-cyan-500/20 group-hover/row:text-cyan-400 transition-colors">
                    <SafeIcon name="ArrowRight" className="text-slate-400 group-hover/row:text-cyan-400" />
                  </div>
                </a>
              ))}
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Liquidity;